<div *ngIf="!!member" class="item">
  <tui-badged-content [style.--tui-radius.%]="50">
    <tui-badge-notification
      *ngIf="!!member.online"
      tuiSlot="bottom"
      [size]="'s'"
      [style.background-color]="'var(--tui-status-positive)'"
    ></tui-badge-notification>

    <app-photo
      class="item__avatar"
      size="m"
      [rounded]="true"
      [type]="'user'"
      [id]="member.isAvatarExists ? member.userId : undefined"
      [text]="member.userName"
      [showPreview]="false"
    ></app-photo>
  </tui-badged-content>

  <div class="item__info">
    <div class="row">
      <div class="item__title text_size-m text_truncate">{{ member.userName }}</div>
    </div>

    <div *ngIf="getRole() as role" class="row">
      <app-badge class="item__role" [value]="role | translate" [color]="'blue'" [size]="'s'"></app-badge>
    </div>
  </div>

  <div class="item__actions">
    <app-actions [mode]="'menu'" [items]="actions" [object]="member">
      <button tuiIconButton type="button" appearance="icon" size="xs">
        <app-icon src="ellipsis-vertical" [size]="'18px'"></app-icon>
      </button>
    </app-actions>
  </div>
</div>
